module.exports = __webpack_public_path__ + "static/media/YF89_2.ebb35ace.jpg";